import React, { Component } from "react";
import { Drawer, Grid, Icon, IconButton } from "@material-ui/core";
import TimeSlot from "../TimeSlot";

export default class TimeSlotDrawer extends Component {
  render() {
    return (
      <Drawer
        open={this.props.openDrawer}
        style={{maxWidth:200}}
        onClose={this.props.closeDrawer}
        anchor="right"
      >
        <Grid container className="slot-side-bar">
          <IconButton
            onClick={this.props.closeDrawer}
            style={{ padding: 0, margin: "22px 0 0 40px", color: "black"}}
            className="close-btn"
          >
            <Icon fontSize={"large"} color={"action"} style={{color: 'black', fontSize: 32}}>
              close
            </Icon>
          </IconButton>
          <TimeSlot
            onCreate={data => this.props.onCreate(data)}
            onCancel={this.props.closeDrawer}
            selectedDays={this.props.selectedDays}
          />
        </Grid>
      </Drawer>
    );
  }
}
